import React from 'react';
import Api, { apiPaths } from 'app/services/api';
import DataView, { ViewDataRow } from '../../DataView/DataView';
import { customerFields } from './CustomerForm';
import { useEffect } from 'react';
import { getFormModAndID } from '../../smart-kit/Form/gridFormUtils';
import { useState } from 'react';
import { useMemo } from 'react';
import * as momentj from 'moment-jalaali';
const CustomerView = () => {
  return (
    <div>
      <DataView
        apipath={apiPaths.CUSTOMERS}
        columns={customerFields}
        // extraCard={CoacheeCourseStats}
      />
    </div>
  );
};

const CoacheeCourseStats = () => {
  const { mod, uuid } = getFormModAndID();
  const [coacheeCourse, setCoacheCourse] = useState();

  const stats = useMemo(() => {
    if (coacheeCourse) {
      let held_sessions = 0;
      let next_session;
      let last_session;
      for (const meeting of coacheeCourse.meetings) {
        if (meeting.title !== 'zero_meeting' && momentj(meeting.starts_at).isBefore(momentj())) {
          held_sessions++;
          last_session = meeting;
        }
        if (momentj(meeting.starts_at).isAfter(momentj())) {
          if (!next_session) {
            next_session = meeting;
          }
        }
      }

      return {
        max_sessions: coacheeCourse.max_sessions,
        held_sessions,
        next_session,
        last_session
      };
    }
  }, [coacheeCourse]);

  useEffect(() => {
    (async () => {
      const res = await Api.get(`${apiPaths.COACHEE_COURSES}/bo/info/${uuid}`);
      console.log(res);
      setCoacheCourse(res);
    })();
  }, []);

  return (
    <React.Fragment>
      {stats && (
        <React.Fragment>
          <ViewDataRow label="Max Sessions">{stats.max_sessions}</ViewDataRow>
          <ViewDataRow label="Held Sessions">{stats.held_sessions}</ViewDataRow>

          <ViewDataRow label="Previous Session">
            {stats.last_session &&
              `${stats.last_session.title} \n ${momentj(stats.last_session.starts_at).format(
                'jYYYY-jMM-jDD HH:mm'
              )}`}
          </ViewDataRow>

          <ViewDataRow label="Next Session">
            {stats.next_session &&
              `${stats.next_session.title} \n ${momentj(stats.next_session.starts_at).format(
                'jYYYY-jMM-jDD HH:mm'
              )}`}
          </ViewDataRow>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default CustomerView;
